var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8016 0C17.3046 0 16.8993 0.393579 16.8993 0.876141V5.06519L12.1344 0.43807C11.7819 0.0958279 11.1899 0.0958279 10.8374 0.43807L0.264327 10.7327C-0.0881091 11.075 -0.0881091 11.6226 0.264327 11.9648C0.616764 12.307 1.18066 12.307 1.5331 11.9648L11.4859 2.29987L21.4669 11.9922C21.6431 12.1633 21.8828 12.266 22.1154 12.266C22.348 12.266 22.5595 12.1633 22.7357 11.9922C23.0881 11.6499 23.0881 11.1023 22.7357 10.7601L19.606 7.72099V0.876141C19.606 0.393579 19.2007 0 18.7038 0H17.8016ZM11.4859 3.91525L1.56129 13.5528V18.3716C1.56129 19.8227 2.77367 21 4.268 21H18.7038C20.1981 21 21.4105 19.8227 21.4105 18.3716V13.5528L11.4859 3.91525ZM9.68143 12.2386H13.2904C13.7873 12.2386 14.1926 12.6322 14.1926 13.1147V18.3716C14.1926 18.8541 13.7873 19.2477 13.2904 19.2477H9.68143C9.18449 19.2477 8.77919 18.8541 8.77919 18.3716V13.1147C8.77919 12.6322 9.18449 12.2386 9.68143 12.2386Z",
    fill: "#1D3557"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.1c76b3d99a540096cea634e3155020df.svg";
export { ForwardRef as ReactComponent };